module.exports = __webpack_public_path__ + "img/support-of-departament-de-cultura.4a40cb93.png";